module.exports = __webpack_public_path__ + "img/1542903028.462fb1f3.jpg";